import { useTranslation } from "react-i18next";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { SectionTitle } from "./Sections";

export const FAQSection = () => {
  const { t } = useTranslation();
  const items = t("faq.items", { returnObjects: true });
  return (
    <section id="faq" className="bg-white py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <SectionTitle title={t("faq.title")} />
        <Accordion type="single" collapsible className="space-y-4">
          {items.map((item, i) => (
            <AccordionItem key={i} value={`faq-${i}`}
              className="bg-brand-cream rounded-2xl border border-brand-green/15 px-6">
              <AccordionTrigger data-testid={`faq-trigger-${i}`}
                className="text-start font-bold text-brand-dark hover:no-underline text-base">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-brand-brown leading-relaxed">{item.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
